import { render, staticRenderFns } from "./DashboardCounter.vue?vue&type=template&id=18c5a76e&scoped=true&"
import script from "./DashboardCounter.vue?vue&type=script&lang=js&"
export * from "./DashboardCounter.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCounter.vue?vue&type=style&index=0&id=18c5a76e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c5a76e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDivider,VIcon,VRow,VTooltip})
